interface SnowplowContext {
  cf: {
    getDomainUserId(): string | undefined;
  };
}

interface SnowplowFunction {
  (callback: (this: SnowplowContext) => void): void;
}

declare global {
  interface Window {
    snowplowKW?: SnowplowFunction;
  }
}

export const getDomainUserId = (): string | undefined => {
  const { snowplowKW } = window;

  // check if snow snowplow is active
  if (typeof snowplowKW === 'undefined') {
    return undefined;
  }

  let domainUserId: string | undefined;
  snowplowKW(function () {
    const { cf } = this;
    domainUserId = cf.getDomainUserId();
  });

  return domainUserId;
};
